module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }